<ng-container *ngIf="preferences$ | async as preferences">
    <ng-container *ngIf="!(loggedIn$ | async) && preferences.loginRequired">
        <da-login-form [targetUrl]="'/partner/' + portal"></da-login-form>
    </ng-container>

    <ng-container *ngIf="((loggedIn$ | async) || !preferences.loginRequired) && portal !=='de-ext'">
        <da-course-list [portal]="portal"></da-course-list>
    </ng-container>
    <section *ngIf="portal ==='de-ext'" class="background-color-nearwhite">
        <da-teaser-boxes-container [data]="'teaserBoxes' | translate"></da-teaser-boxes-container>
    </section>
</ng-container>
